import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';

// Generate Sales Data
function createData(time, amount) {
  return { time, amount };
}

// const data = [
//   createData('Jan', 3),
//   createData('Feb', 0),
//   createData('Mar', 0),
//   createData('Apr', 1),
//   createData('May', 2),
//   createData('June', 0),
//   createData('July', 5),
//   createData('Aug', 0),
//   createData('Sept', 0),
//   createData('Oct', 0),
//   createData('Nov', 0),
//   createData('Dec', 3),

// ];


export default function Chart({data}) {
  const theme = useTheme();

  return (
    <React.Fragment>
      <Title>Current Year Booking</Title>
      <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <XAxis dataKey="time" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
            >
              Booking
            </Label>
          </YAxis>
          <Line type="monotone" dataKey="amount" stroke={theme.palette.primary.main} dot={true} />
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/component/chart.js